import React from "react";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { Icon } from "rhombus-react";

import { formatBytes, isSocialCreative } from "utils/common";
import { EmptyDash } from './EmptyDash';

export function TotalFileSizeColumn(props){
	let { value, dependentValues } = props
		, messageType = dependentValues?.type || "Item"
		, { sizeLimitSelector = ()=>Infinity, shouldShowWarning } = dependentValues || {}
		, isNA  = dependentValues ? dependentValues.isNA : false
		/* istanbul ignore next */
		, currentLimit =  useSelector(sizeLimitSelector)
		, isOverLimit = shouldShowWarning && (value > currentLimit)
		, classes = classNames("total-filesize", { "over-limit" : isOverLimit })
		, $icon = null
		, content = null
		;

	if(dependentValues && isSocialCreative(dependentValues)){
		content = <EmptyDash />;
	} else {
		content = isNA ? "N/A" : formatBytes(value, 1);
	}

	if(isOverLimit){
		$icon = <Icon name="fas fa-exclamation-triangle" className={classNames(classes)} data-multiline={true} data-tip={`${messageType} is over the <br/> file size limit (${formatBytes(currentLimit)})`} />;
	}

	return (
		<span className={classNames(classes)}>
			{content}
			{$icon}
		</span>
	);
}

TotalFileSizeColumn.displayName = "TotalFileSizeColumn";

const TotalFileSizeCell = {
	key: "filesize",
	name: "File Size",
	formatter:TotalFileSizeColumn,
	width:130,
	sortable:true,
	resizable:true,
};

export default TotalFileSizeCell;
